module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.e7dec9c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fonts/materialdesignicons-webfont.ttf?v=5.1.45
// module id = DDlu
// module chunks = 1